import React from "react"
import Modal from "react-bootstrap/Modal"
import * as styles from "./Styles/PC.module.scss"

import Loader from "../../Loader"

const CategoryModal = (props) => {
  const onClick = (e, category) => {
    e.preventDefault()
    props.onChange(category)
  }

  return (
    <Modal show={props.show} onHide={props.onHide}>
      <Modal.Header>
        <div className={styles.modalHeader}>カテゴリーをえらぶ</div>
      </Modal.Header>
      <Modal.Body>
        <Loader
          show={props.categories.length == 0}
          color="green"
          small={false}
        />
        {props.categories &&
          props.categories.map((c, i) => (
            <React.Fragment key={i}>
              <div className={styles.header}>
                <h3>{c.name}</h3>
              </div>
              <div className={styles.children}>
                {c.children &&
                  c.children.map((child, j) => (
                    <React.Fragment key={j}>
                      <div className={styles.child}>
                        <a
                          href="#"
                          onClick={(e) => {
                            onClick(e, child)
                          }}
                        >
                          {child.name}
                          {props.placeCountByCategories &&
                            Object.keys(props.placeCountByCategories).length >
                              0 && (
                              <span className={styles.placesCount}>
                                ({props.placeCountByCategories[child.id] || "0"}
                                )
                              </span>
                            )}
                        </a>
                      </div>
                    </React.Fragment>
                  ))}
              </div>
            </React.Fragment>
          ))}
      </Modal.Body>
    </Modal>
  )
}

export default CategoryModal
